import React from "react";

// Interactive embedded OpenStreetMap (no API key needed).
export function MapEmbed({ lat, lng, height = 220, zoom = 15 }) {
  if (lat == null || lng == null) return null;
  const d = 0.01;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  return (
    <div className="overflow-hidden rounded-xl border border-border">
      <iframe
        title="Location map"
        data-testid="location-map"
        src={src}
        style={{ width: "100%", height, border: 0 }}
        loading="lazy"
      />
      <a
        href={`https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`}
        target="_blank"
        rel="noreferrer"
        className="block bg-secondary px-3 py-2 text-center text-xs font-medium text-brand hover:underline"
      >
        Open in Maps
      </a>
    </div>
  );
}
